import head from "lodash/head"
import filter from "lodash/filter"
import get from "lodash/get"
import { ItemList } from '../orm'

class AlbumList extends ItemList {

  getEntityKey() {
    return "customer/album"
  }

  async getLogoForAlbumName(album_name) {
    const albums = this.getVisibleObjects()
    const album = head(filter(albums, (x) => x.name === album_name))
    return await get(album, ["album_photograph"])
  }
}

export const albumList = new AlbumList("album_default")
export const albumListForEventTab = new AlbumList("album_for_event_tab_default")
